import { Link } from "react-router-dom";
import { ArrowRight, Wallet2 } from "lucide-react";
import Unavailable from "@/components/Unavailable";

export default function Wallet() {
  return (
    <div className="max-w-5xl mx-auto py-10">
      <div className="eyebrow">PORTEFEUILLE</div>
      <h1 data-testid="wallet-title" className="font-display text-3xl mb-5">Mon portefeuille.</h1>

      <Unavailable
        testid="wallet-unavailable"
        title="Aucun crédit, aucun solde, aucune transaction."
        text="Les paiements ne sont pas activés : Perform ne détient aucune coordonnée bancaire et n'a encaissé aucune somme. Ce portefeuille se remplira quand les réservations ouvriront."
        note="Le modèle tarifaire est publié à l'avance : vous payez la séance, le coach fixe son prix, Perform prélève une commission sur sa part."
        to="/tarifs"
        linkLabel="Voir les tarifs"
      />

      <section className="wallet-explainer">
        <h2><Wallet2 size={15} />Comment cela fonctionnera</h2>
        <ol>
          <li><strong>Vous réservez une séance.</strong> Le montant est autorisé sur votre moyen de paiement, pas encaissé.</li>
          <li><strong>La séance a lieu.</strong> Le paiement est capturé à ce moment-là, pas avant.</li>
          <li><strong>Le coach est payé.</strong> Versement hebdomadaire, commission déduite, relevé détaillé.</li>
          <li><strong>En cas d'annulation</strong> plus de 24 heures avant, vous êtes intégralement remboursé.</li>
        </ol>
        <Link to="/legal/annulation" className="landing-link">Politique d'annulation<ArrowRight size={13} /></Link>
      </section>
    </div>
  );
}
